'use client';

import { LoanReturnAdvancedResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  result: LoanReturnAdvancedResult;
  translations: ToolsTranslations['loanReturnAdvanced'];
}

export default function ResultsDisplay({ result, translations }: Props) {
  const currencyFormat = (amount: number) => amount.toLocaleString('sv-SE') + ' kr per år';

  return (
    <div className="space-y-6">
      <div className="rounded-lg bg-gray-50 p-4 border border-gray-200">
        <div className="text-xl font-semibold text-blue-900 mb-1">{translations.netAmountLabel}</div>
        <div className="text-2xl font-semibold text-blue-900">{result.netAmountPerYear !== null ? currencyFormat(result.netAmountPerYear) : '—'}</div>
      </div>
      <div className="rounded-lg bg-gray-50 p-4 border border-gray-200">
        <div className="text-xl font-semibold text-blue-900 mb-1">{translations.roePercentLabel}</div>
        <div className="text-2xl font-semibold text-blue-900">{result.roePercentPerYear !== null ? `${result.roePercentPerYear.toFixed(2)} % per år` : '—'}</div>
      </div>
      <div className="rounded-lg bg-gray-50 p-4 border border-gray-200">
        <div className="text-xl font-semibold text-blue-900 mb-1">{translations.leverageLabel}</div>
        <div className="text-2xl font-semibold text-blue-900">{result.leverageMultiple !== null ? `${result.leverageMultiple} ggr` : '—'}</div>
      </div>
      {!result.isValid && result.message && (
        <p className="text-sm text-red-600">{result.message}</p>
      )}
    </div>
  );
}


